import * as React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';

interface UserAvatarProps {
  welcomeText?: string;
  name?: string;
  title?: string;
  imageUrl?: string;
  vertical?: boolean;
  nameStyle?: any;
  titleStyle?: any;
}

export const UserAvatar: React.FC<UserAvatarProps> = (props) => {
  const {
    welcomeText = '',
    name = '',
    imageUrl = '',
    title = '',
    vertical = false,
    nameStyle = {},
    titleStyle = {},
  } = props;

  return (
    <Box
      sx={
        vertical
          ? {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }
          : {
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }
      }
    >
      {imageUrl ? (
        <Avatar
          alt={`${name}`}
          src={imageUrl}
          sx={{
            backgroundColor: 'white',
            borderWidth: 2,
            borderColor: 'white',
            borderStyle: 'solid',
          }}
        />
      ) : (
        <Avatar>
          <Person
            sx={{
              fontSize: 30,
            }}
          />
        </Avatar>
      )}

      <Box display="flex" flexDirection="column" justifyContent="center" marginLeft={vertical ? 0 : 2}>
        <Typography
          variant="h6"
          sx={{
            ...nameStyle,
          }}
        >
          {welcomeText} {name}
        </Typography>

        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            lineHeight: 1,
            ...titleStyle,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};
